module.exports = {"2":[74,698,403],"3":[],"4":[74,698,403],"5":[698,403,74],"6":[318,73,403],"7":[74,349,698,403],"8":[],"9":[],"10":[],"11":[],"12":[],"13":[],"14":[],"15":[],"16":[],"17":[],"18":[],"19":[],"20":[],"21":[],"22":[],"23":[],"24":[],"25":[],"26":[],"27":[],"28":[],"29":[],"30":[74,349,698,403],"31":[74,403,698],"32":[],"33":[],"34":[],"35":[],"36":[],"37":[],"38":[],"39":[74,403,698],"40":[],"41":[74,403,698],"42":[]}


//////////////////
// WEBPACK FOOTER
// ./src/components/grid/glossary/sport-outcome-headers.json
// module id = 1076
// module chunks = 7